import React from "react";
import { useMenuSection } from "react-aria";
import { Node, TreeState } from "react-stately";
import MenuItem from "./MenuItem";
import { Prettify } from "../../utils/types";
import Flex from "../Flex";
import * as S from "./styled";

export type MenuSectionProps<T extends object> = Prettify<{
    state: TreeState<T>;
    section: Node<T>;
}>;

const MenuSection = <T extends object>({ section, state }: MenuSectionProps<T>) => {
    const { itemProps, headingProps, groupProps } = useMenuSection({
        heading: section.rendered,
        "aria-label": section["aria-label"]
    });

    return (
        <Flex column as="li" {...itemProps}>
            {section.rendered && <S.SectionItemHeading {...headingProps}>{section.rendered}</S.SectionItemHeading>}
            <S.List {...groupProps} column as="ul">
                {[...section.childNodes].map(node => (
                    <MenuItem key={node.key} item={node} state={state} />
                ))}
            </S.List>
        </Flex>
    );
};

export default MenuSection;
